module.exports = __webpack_public_path__ + "static/img/rs_bot2.344501b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/rs_bot2.png
// module id = V8aZ
// module chunks = 1